var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #293b6b;\n        fill-rule: evenodd;\n      }\n\n      .st1 {\n        fill: #bd1006;\n        stroke: #1d1d1b;\n      }\n\n      .st1, .st2 {\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n\n      .st3 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: none;\n        stroke: #3c3c3b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_11",
    "data-name": "Lager_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15.6,
    cy: 15.5,
    r: 14.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,3.8v7.5s-5.2,0-5.2,0c-.4,1.3-.6,2.7-.6,4.2s.2,2.8.6,4.1h5.2v7.5c2.3,1.8,5.2,2.9,8.3,3v-10.6h14.8c.4-1.3.6-2.7.6-4.1s-.2-2.8-.6-4.2h-14.8V.8c-3.1.1-6,1.2-8.3,3,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.4.9v11.8h16.6c0-.5-.2-1-.3-1.5h-14.8V.8c-.5,0-1,0-1.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8,12.7V2.8c-.5.3-1,.6-1.4,1h0v7.5H1.4c-.1.5-.2.9-.3,1.4h6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.4,18.2v11.8c.5,0,1,.1,1.5.1v-10.6h14.8c.1-.4.2-.9.3-1.3H13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8,28.1v-9.9H1.1c0,.5.2.9.3,1.4h5.2v7.5c.4.3.9.7,1.4,1Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 15.6,
    cy: 15.5,
    r: 14.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.e58251a34a67870956b83d99b51cb80b.svg";
export { ForwardRef as ReactComponent };